import { IonContent } from '@ionic/react';
import React, { useEffect } from 'react';

import { amplitudeModule } from '@/modules/amplitude';
import { LogoWithAppName } from '@/pages/Onboarding/components/LogoWithAppName';
import { useOnboarding } from '@/pages/Onboarding/context.tsx';
import { canLogEvents } from '@/utils/canLogEvents.ts';

import {
  BackgroundImage,
  MainImage,
  PageStyles,
  PageSubtitleStyles,
  PageTitleStyles,
} from './WelcomeScreen.styles.ts';

export const WelcomeScreen: React.FC = () => {
  React.useEffect(() => {
    if (canLogEvents()) {
      amplitudeModule.logEvent('onboarding_screen', {
        seen: 'Welcome Screen G6',
      });
    }
  }, []);

  const { wizard } = useOnboarding();

  useEffect(() => {
    setTimeout(() => {
      wizard.nextStep();
    }, 3500);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <PageStyles background="none">
      <IonContent>
        <LogoWithAppName className="app-logo" withCaption={false} />

        <PageTitleStyles
          className="page-title"
          component="h1"
          variant="headline-large"
          align="center"
        >
          Create your Own
          <br />
          <PageSubtitleStyles
            variant="inherit"
            color="pride-gradient"
            component="span"
            className="page-subtitle"
          >
            AI Boyfriend
          </PageSubtitleStyles>
        </PageTitleStyles>
        <BackgroundImage
          src="/assets/layout-own-ai-man/pride/pride-flag-v2.png"
          alt="Background Image"
        />
        <MainImage
          src="/assets/layout-own-ai-man/pride/g6.png"
          alt="Main Image"
        />
      </IonContent>
    </PageStyles>
  );
};
